import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ViewChild, NgZone, ElementRef, Renderer2, HostListener } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { QueryProcessorService } from '../../services/query-services/query-processor.service';
import { QueryFormService } from '../../services/query-services/query-form/query-form.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Subscription } from 'rxjs';
import { StandardUIService } from '../../services/standardui-service/standardui-service';
import { MetaData } from '../../services/metadata/metadata.service';
import { ObjectController } from '../../services/object-controller/objectcontroller.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CryptoService } from '../../services/crypto-services/crypto-services';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
declare var bootstrap: any
declare var $: any;
import { LocalStorageService } from 'src/app/services/localstorage-service/localstorage-service';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
require('../../../assets/vendor/js/dataTableDateSorting.js', );

export class QueryResults {
  id: number;
  firstName: string;
  lastName: string;
  dob: string;
}

@Component({
  selector: 'app-query-processor',
  templateUrl: './query-processor.component.html',
  styleUrls: ['./query-processor.component.scss']
})

export class QueryProcessorComponent implements OnInit, AfterViewInit {
  searchtext: any;
  brodCastChnage: BehaviorSubject<any> = new BehaviorSubject(null);
  private subscription: Subscription;
  @Input() componentContext;
  @Output() componentSelection = new EventEmitter<any>();
  searchKeys = ['id', 'firstName', 'lastName', 'dob'];
  sortBy = 'firstName';
  sortDesc = false;
  perPage: any = 500;
  pageNo = 1;
  totalItems = 0;
  filterVal = '';
  currentPage = 1;
  infoMsg: boolean;
  loading: boolean = false;
  outputData: any;
  entity: string;
  originalQueryProcessorArray = [];
  queryProcessorArray: QueryResults[] = [];
  queryProcessorFormGroup: FormGroup;
  submitted = false;
  offset:any = 0;
  reportData: any = [];
  headings: any;
  rowData: any = [];
  editReportForm: FormGroup;
  fbGpObject: any = {};
  tabName: string;
  cols: any = [];
  rows: any = [];
  objectMetaData: any;
  editEnityName: string;
  editID: number;
  containerHeight: any;
  otherStyles = {};
  tbody = {};
  tcontainer = {};
  userRole: any;
  fav = false;
  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('menu') menu;
  @ViewChild('reportPopupForm') public reportPopupForm;
  showHideFilter: boolean = false;
  advsearch: any;
  saveAgentRecentAccesspayload:any=null
  multiEditableFieldsPayload = [];
  checkAllEditableCols;
  checkAllEditableRows;
  checkboxid: any = [];
  /** Encrypted payloads for report grid (virtual rows). */
  encColsStr = '';
  encRowStrings: string[] = [];
  reportEncCells: string[][] = [];
  reportIndexColIsHash = false;
  /** Fixed row height (px) for CDK virtual scroll — tune with CSS line-height. */
  readonly reportVirtualRowHeight = 40;
  @ViewChild(CdkVirtualScrollViewport) reportViewport?: CdkVirtualScrollViewport;
  @ViewChild('reportHeadScroll') reportHeadScroll?: ElementRef<HTMLElement>;
  /** Row indices with multiselect checked (all rows in current page, not only visible DOM). */
  multiselectSelectedRows = new Set<number>();
  private reportColumnResizeTimer: ReturnType<typeof setTimeout> | null = null;
  /** Client-side sort on current page (column index + direction). */
  reportSortColumnIndex: number | null = null;
  reportSortAscending = true;
  /** Snapshot of rows from last /query/run (before client filter + sort). */
  reportApiRowData: any[][] = [];
  /** Last applied column widths — avoids re-layout when only row order changes (sort). */
  private reportCachedColumnWidths: number[] | null = null;
  private reportCachedViewportWidth = 0;
  private reportColumnSyncInProgress = false;

  constructor(
    private queryProcessorService: QueryProcessorService,
    private spinnerService: SpinnerVisibilityService,
    private formBuilder: FormBuilder,
    private queryFormsService: QueryFormService,
    private modalService: NgbModal,
    private sus: StandardUIService,
    private metadata: MetaData,
    private objc: ObjectController,
    private cryptoService: CryptoService,
    private renderer: Renderer2,
    private _ngZone: NgZone,
    private localStorageService: LocalStorageService,
    private agentscriptservice:AgentscriptService_updated,
    private hostRef: ElementRef
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      /**
       * Only run when toggleButton is not clicked
       * If we don't check this, all clicks (even on the toggle button) gets into this
       * section which in the result we might never see the menu open!
       * And the menu itself is checked here, and it's where we check just outside of
       * the menu and button the condition abbove must close the menu
       */
      //  if(e.target !== this.toggleButton.nativeElement && e.target!==this.menu.nativeElement){
      //   // alert()
      //      //this.showHideFilter=false;
      //     }
    });
  }
  // --- Multi-tab awareness and sync additions ---
  tabId: string = '';
  @Input() multiTabSyncKey: string = 'query-processor-multitab-sync';

  ngOnInit() {
    this.userRole=localStorage.getItem("role")
    console.log(this.userRole); 
    console.log("in query processor")

    this.queryProcessorFormGroup = this.queryFormsService.toFormGroup(this.originalQueryProcessorArray);
    this.refreshReportViewportMaxHeight();
    // Generate a unique tab ID
    this.tabId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    // Listen for localStorage events from other tabs
    window.addEventListener('storage', this.handleStorageEvent.bind(this));
    // Optionally, announce this tab is open (for awareness)
    localStorage.setItem(this.multiTabSyncKey + '-open', this.tabId);
  }



  handleStorageEvent(event: StorageEvent) {
    if (event.key === this.multiTabSyncKey && event.newValue) {
      try {
        const data = JSON.parse(event.newValue);
        // Ignore events from this tab
        if (data.tabId === this.tabId) return;
        // Handle actions from other tabs
        if (data.action === 'refresh-query') {
          // Optionally, show a notification or auto-refresh
          // For demo: auto-refresh data
          this.getFilteredData(0);
          // Or: alert('Query updated in another tab!');
        }
      } catch (e) { /* ignore */ }
    }
  }

  broadcastMultiTabAction(action: string, payload: any = {}) {
    const data = { tabId: this.tabId, action, payload, timestamp: Date.now() };
    localStorage.setItem(this.multiTabSyncKey, JSON.stringify(data));
  }

  ngAfterViewInit() {
    // console.log(this.componentContext.advanceSearch.value)
    // var tableCont = document.querySelector('.fixed_header')

    // function scrollHandle (e){
    //   var scrollTop = this.scrollTop;
    //   this.querySelector('thead').style.transform = 'translateY(' + scrollTop + 'px)';
    // }

    // tableCont.addEventListener('scroll',scrollHandle)


    console.log("in ngafter view init")
    console.log(this.componentContext)

    let self = this;
    this.queryProcessorService.getQueriesService(this.componentContext.id).subscribe(data => {
      console.log(data);
      this.originalQueryProcessorArray = data;
      if (data.length > 0) {
        this.originalQueryProcessorArray = data.sort(function (obj1, obj2) {
          return obj1.sequenceOrder - obj2.sequenceOrder;
        });
      }

      //console.log('originalQueryProcessorArray ', this.originalQueryProcessorArray);

      this.queryProcessorFormGroup = this.queryFormsService.toFormGroup(this.originalQueryProcessorArray);
      // Run the report exactly once: if any filter has a default value, wait for it
      // to be patched into the form first; otherwise run immediately.
      const hasDefaultValue = data.some((d: any) => d.defaultValue);
      if (hasDefaultValue) {
        setTimeout(() => {
          this.getFilteredData(0);
        }, 200);
      } else {
        this.getFilteredData(0);
      }

    },
      error => {
        //console.log('error in getQueriesService');
      });
    //Checkuncheck funtionalit

    //let checkboxid = [];
    //let multiEditableFields = [];

    // Namespace for this instance
    const ns = `.qp_${this.componentContext.id}`;

    // Remove any previous handlers for this instance
    $(document).off(ns);

    // Multiselect .checkall / .checkrow: handled in Angular (virtual scroll keeps only visible rows in DOM).
    // end of Check
    // Open Report Start
    // $(document).on("click", '#data-table' + this.componentContext.id + ' .triggeropen', function (e) {
    //   $('#data-table' + this.componentContext.id + ' .openReport').trigger('click')
    // })
    //$(document).on("click", ".openReport", function (e) {

    $(document).on('click' + ns, '#data-table' + this.componentContext.id + ' .openReport', function (e) {
      self.saveAgentRecentAccesspayload = null;
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      let row: any = JSON.parse(self.cryptoService.get($(this).data('row')));
      if(item.colaction == 'Open'){
        for(let i =0;i < row.length;i++){
          if(row[i].dataType == "ACTION" && row[i].action.actionType == item.colaction){
            item = row[i];
          }
        }
      }
      let casetypeval = row.filter((x: any) => (x.colName && x.colName.toString().includes("casetype")));
      var refferencecolumn;
      refferencecolumn = row.filter((x: any) => (x.fieldName && x.fieldName.toString().includes("refno")))
      // tabName + '-' + item.action.value
      let tabName: any = $(this).data('tabname');
      let queryimage: any
      switch (tabName) {
        case "Answer": queryimage = "../../assets/images/existinganswer.svg"
        self.saveAgentRecentAccesspayload={"answerid":item.action.value}
          break;
        case "Contact": queryimage = "../../assets/images/Profile.svg"
        self.saveAgentRecentAccesspayload={"contactid":item.action.value}
          break;
        case "Incident": queryimage = "../../assets/images/existingservicerequest.svg"
        self.saveAgentRecentAccesspayload={"incidentid":item.action.value}
          break;
      }
      // return false;
      if (tabName == 'Contact') {
        let fullname = [];
        row.forEach((item) => {
          if (item.fieldName) {
            if (item.fieldName.includes('firstname') || item.fieldName.includes('lastname')) {
              fullname.push(item.value);
            }
          }
        })
        tabName = fullname.join(" ");
      }
      // let pageName;
      // row.forEach((item)=>{
      //   if(item.dataType == 'ACTION' && item.action.actionType == 'Hide'){
      //     pageName = item.action.value
      //   }
      // })
      let d;
      if (refferencecolumn.length == 0) {
        if(item.action.entityName == 'Answer'){
          d = { id: item.action.value, name: tabName + '-' + item.action.value, type: 'answer', entityName: item.action.entityName, department: item.action.entityName, src: queryimage };
        }else{
          d = { id: item.action.value, name: tabName + '-' + item.action.value, type: 'object', entityName: item.action.entityName, department: item.action.entityName, src: queryimage };
        } 
        
      } else {        
        if(casetypeval.length > 0 && !casetypeval[0].value){          
          d = { id: item.action.value, name: refferencecolumn[0].value, type: 'alertincident', entityName: 'opencreatedalert', department: null, src:"https://fortwayne-portal.thesmartcity311.com/assets/images/AlertIncidentActive.svg" };          
        }else{
          d = { id: item.action.value, name: refferencecolumn[0].value, type: 'object', entityName: item.action.entityName, department: item.action.pagevalue, src: queryimage };
        }        
      }
      //d = { id: item.action.value, name: refferencecolumn[0].value, type: 'object', entityName: item.action.entityName,department: row[row.length-1].action.value};

      
      //console.log(row[row.length-1].action.value);
      // console.log(d);
      // return false;
      self.componentSelectionEmitter(d);
      if (self.saveAgentRecentAccesspayload != null) {
        self.sus.saveAgentRecentAccess(self.saveAgentRecentAccesspayload).subscribe((data: any) => {
          self.agentscriptservice.agentrecentaccess();
        });
      }
    })
    // Open Report End
    $(document).on('click' + ns, '#data-table' + this.componentContext.id + ' .triggeropen', function () {
      $('tr.selected').removeClass('selected');
      $(this).addClass('selected');
    });


    // const table = $('#data-table11').dataTable();

 

    //Add Fav Start
    $(document).off('click' + ns, '#data-table' + this.componentContext.id + ' .addtofav').on('click' + ns, '#data-table' + this.componentContext.id + ' .addtofav', function (e) {
      if($(this).find('i').hasClass('fa-duotone')){
        self.fav = true;
        $(this).find('i').removeClass('fa-duotone');
        
      }else{
        self.fav = false;
        $(this).find('i').addClass('fa-duotone');
      }           
      //return false;      
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      let row: any = JSON.parse(self.cryptoService.get($(this).data('row')));
       //if(item.colaction == 'Open'){
        for(let i =0;i < row.length;i++){
          if(row[i].dataType == "ACTION" && row[i].action.actionType == 'Open'){
            item = row[i];
          }
        }
      //}
      console.log(row);
      console.log(item.action.value);
      if(item.hasOwnProperty('action')) {
        let payload = {
          "incidentid" : item.action.value,
          "fav" : self.fav
        }
        self.addToFav(payload);
      }      
    })
    //Add Fav End
    // Open Child Start
    $(document).on('click' + ns, '.openChild', function (e) {
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      let d = { id: item.value, name: item.objectName + '-' + item.value, type: 'object', entityName: item.objectName };
      self.componentSelectionEmitter(d);
    })
    // Open Child End
    // Edit Report Start
    $(document).off('click' + ns, '#data-table'+this.componentContext.id+' .editReport').on('click' + ns, '#data-table'+this.componentContext.id+' .editReport', function (e) {
      self.checkboxid = [];
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      console.log("Dollar this dot row lo emanna peint ayitada");
      console.log($(this).data('obj'));
      console.log($(this).data('cols'));
      console.log($(this).data('row'));
      let itemCols: any = JSON.parse(self.cryptoService.get($(this).data('cols')));
      let itemRow: any = JSON.parse(self.cryptoService.get($(this).data('row')));
      console.log(itemRow)
      console.log(itemCols)
      console.log(item.action.value);
      console.log(item.action.entityName);
      self.edit(itemRow, item.action.entityName, item.action.value, itemCols);

    })
    //Edit Report End

    //Link Report Start
    //$(document).off('click', '.linkReport').on('click','.linkReport',function(e){
    $(document).on('click' + ns, '.linkReport', function (e) {
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      let tabName: any = $(this).data('tabname');
      let itemCols: any = JSON.parse(self.cryptoService.get($(this).data('cols')));
      let itemRow: any = JSON.parse(self.cryptoService.get($(this).data('row')));
      let d = { id: item.action.value, name: 'ManualLink-' + tabName + '-' + item.action.value, type: 'reportlink', entityName: item.action.entityName, rowData: itemRow, headings: itemCols }
      self.componentSelectionEmitter(d);
    })
    // Link Report End

    //Mark as case Start
    $(document).on('click' + ns, '.markcase', function (e) {
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      console.log(item)
      console.log(item.action.value)
      self.markAsCase(item.action.value);
    })
    //Mark as case End

    //Fixed Table header start
    // $("div.table-cont").scroll(function () {
    //   let scrollTop: any = $(this).scrollTop();
    //   let x = $(this).find('table').position();
    //   let b = $(this).find('.btn-wrapper').position();
    //   if (scrollTop > 0) {
    //     $(this).find('thead tr th').css({ 'position': 'sticky', 'top': x.top, 'background-color': 'white' }).addClass('sticky');
    //     $(this).find('.btn-wrapper').css({ 'position': 'sticky', 'top': '0px', 'background-color': 'white' }).addClass('sticky');
    //     //$(this).find('thead').css({'transform' : 'translateY(' + scrollTop + 'px)','background':'white','width':'100%'});
    //     //$(this).find('.btn-wrapper').css({'transform' : 'translateY(' + scrollTop + 'px)'});
    //   } else {
    //     //let x = $(this).find('thead').position();
    //     //console.log("Top: " + x.top + " Left: " + x.left);
    //     $(this).find('thead tr th').css({ 'position': 'relative', 'top': 'auto' }).removeClass('sticky');
    //     $(this).find('.btn-wrapper').css({ 'position': 'relative', 'top': 'auto' }).removeClass('sticky');
    //     //$(this).find('thead').css({'transform' : 'translateY(' + scrollTop + 'px)','background':'white','width':'auto'});
    //     //$(this).find('.btn-wrapper').css({'transform' : 'translateY(' + scrollTop + 'px)'});
    //   }
    // });
    //Fixed Table header end

    setTimeout(() => {
      if (this.componentContext.hasOwnProperty('advanceSearch')) {
        this.advsearch = true;
        // this.getFilteredData(0)
      }
    })

  }
  ngOnDestroy() {
    if (this.reportColumnResizeTimer != null) {
      clearTimeout(this.reportColumnResizeTimer);
    }

    // Remove all event handlers for this instance
    if (this.componentContext && this.componentContext.id) {
      $(document).off(`.qp_${this.componentContext.id}`);
    }
     // Clean up event listener
     window.removeEventListener('storage', this.handleStorageEvent.bind(this));
     // Optionally, announce this tab is closed
     localStorage.removeItem(this.multiTabSyncKey + '-open');
  }
  getPergeCache(){
    this.queryProcessorService.getPergeCache().subscribe((data) => {
      console.log(data);
      if(!data){
        alert("Something Went Wrong")
      }
    })
  }
  markAsCase(id) {
    this._ngZone.run(() => {
      this.queryProcessorService.markAsCase(id).subscribe((data: any) => {
        // console.log(data);
        if (data.error) {
          Swal.fire('Oops...!', data.error, 'error');
        } else {
          Swal.fire('Success!', 'Record successfully updated!', 'success');
          $('.search').trigger('click');
        }
      })
    })

  }

  rowObj: any = {};
  customSortCols = [];
  /** From API: number of columns to pin on the left when horizontally scrolling. */
  fixedColStart: number | null = null;
  /** From API: number of columns to pin on the right. */
  fixedColEnd: number | null = null;
  /** Derived counts + pixel offsets for position:sticky (set in recomputeStickyOffsetsFromWidths). */
  reportFixedLeftCols = 0;
  reportFixedRightCols = 0;
  reportStickyLeftPx: number[] = [];
  reportStickyRightPx: number[] = [];
  /**
   * Pinned columns use position:sticky and overlap badly on small viewports.
   * Disable for widths at or below this (phones, tablets, iPad portrait/landscape at 1024).
   */
  private readonly reportStickyColumnsMaxViewportPx = 1024;
  getFilteredData(offsetData) {
    //console.log(offsetData);
    //this.pageNo = 1;
    
    //console.log('save filtered Data');
    this.loading = true;
    $("#data-table" + this.componentContext.id + "_wrapper").remove();
    this.submitted = true;
    this.offset = offsetData;
    this.refreshPagination();
    //console.log(this.queryProcessorFormGroup);
    if (this.queryProcessorFormGroup.invalid) {
      //console.log('Invalid form');
      return;
    }
    let tempPayload: any = {};
    //console.log(this.queryProcessorFormGroup.value);
    //console.log(this.originalQueryProcessorArray);
    for (let query in this.queryProcessorFormGroup.value) {
      //console.log(query);
      if (Array.isArray(this.queryProcessorFormGroup.value[query])) {
        //console.log(this.getArray(this.queryProcessorFormGroup.value[query]));
        this.queryProcessorFormGroup.value[query] = this.getArray(this.queryProcessorFormGroup.value[query]).join(",");
      }
      for (let index in this.originalQueryProcessorArray) {
        if (this.originalQueryProcessorArray[index].placeHolder == query && this.originalQueryProcessorArray[index].dataType == 'Date' && this.queryProcessorFormGroup.value[query] != "" && this.queryProcessorFormGroup.value[query] != null) {
          //console.log('sssddd',this.queryProcessorFormGroup.value[query])
          tempPayload[query] = (new Date(this.queryProcessorFormGroup.value[query]).getTime()) / 1000;
        } else if (this.queryProcessorFormGroup.value[query] != "" && this.queryProcessorFormGroup.value[query] != null && this.originalQueryProcessorArray[index].placeHolder == query) {
          //console.log('sssddd',this.queryProcessorFormGroup.value[query])
          if(query == 'phonenumber'){
            tempPayload[query] = this.queryProcessorFormGroup.value[query].replace(/\D/g,'');
          }else if(query == 'street'){
            tempPayload[query] = this.queryProcessorFormGroup.value[query].replace(" ", "").trim();
          }else{
            tempPayload[query] = this.queryProcessorFormGroup.value[query];
          }
        }
      }
    }
    //console.log(tempPayload);

    if (this.componentContext?.advanceSearch) {
      var filteredData = Object.fromEntries(
        Object.entries(this.componentContext.advanceSearch).filter(([key, value]) => value !== "" && value != null)
      );

    }

    let payload: Object;
    if (Object.keys(tempPayload).length == 0 && this.componentContext.hasOwnProperty('advanceSearch') && this.advsearch) {
      // this.advsearch=false;
      console.log('advance')
      payload = {
        "queryId": this.componentContext.id,
        "params": Object.keys(filteredData).length == 0 ? tempPayload : filteredData,
        "offset": parseInt(this.offset),
        "letter": this.componentContext.letter ? this.componentContext.letter : '',
        "perpage": parseInt(this.perPage)
        // "params": (this.queryProcessorFormGroup.value)? this.queryProcessorFormGroup.value : ""
      }
    }
    else {
      //console.log('filteredData')
      // alert(this.filteredData)
      // this.filteredData=[]
      // delete this.componentContext.advanceSearch;
      //console.log(this.componentContext)
      // alert('temp')
      payload = {
        "queryId": this.componentContext.id,
        "params": tempPayload,
        "offset": parseInt(this.offset),
        "letter": this.componentContext.letter ? this.componentContext.letter : '',
        "perpage": parseInt(this.perPage)
        // "params": (this.queryProcessorFormGroup.value)? this.queryProcessorFormGroup.value : ""
      }
    }

    //console.log(payload);


    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.customSortCols = [];
    this.outputData = [];
    this.reportApiRowData = [];

    this.subscription = this.queryProcessorService.searchQueriesService(payload).subscribe(data => {
      //console.log('saved query');
      this.checkboxid = [];
      this.multiselectSelectedRows = new Set();
      this.closeFilter();
      this.loading = false;
      //console.log(data);

      if (data != null && data != undefined && data != '') {
        this.advsearch = false;
      }
      //this.brodCastChnage.next(this.outputData);
      //data.cols.unshift(" ");
      this.fixedColStart = null;
      this.fixedColEnd = null;
      if (data.rowData?.length > 0) {
        const firstRow = data.rowData[0] as any[];
        for (let k = 0; k < firstRow.length; k++) {
          const cell = firstRow[k];
          if (
            cell?.displayfixedpositionstart != null &&
            cell?.displayfixedpositionend != null
          ) {
            this.fixedColStart = Number(cell.displayfixedpositionstart);
            this.fixedColEnd = Number(cell.displayfixedpositionend);
            break;
          }
        }
      }
      for (let j = 0; j < data.rowData.length; j++) {
        //this.rowObj = {};
        if (j == 0) {
          for (let k = 0; k < data.rowData[j].length; k++) {
            if (data.rowData[j][k].colName == 'hidesort') {
              this.rowObj = {};
              this.rowObj['orderable'] = false;
              this.rowObj['targets'] = k;
              this.customSortCols.push(this.rowObj);
              // { "orderable": false, "targets": [0, 4, 5, 6] },
            }
            if (data.rowData[j][k].dataType == 'Date' || data.rowData[j][k].dataType == 'DateTime') {
              //var nm = data.cols[k].replace(/[^A-Z0-9]+/ig, "");
              //console.log('date fields index',k);
              this.rowObj = {};
              this.rowObj['type'] = 'de_date';
              this.rowObj['targets'] = k;
              this.customSortCols.push(this.rowObj);
            }
          }

          break;
        }
        // this.rows.push(this.rowObj);
      }
      this.outputData = data;
      this.reportSortColumnIndex = null;
      this.reportSortAscending = true;
      this.searchtext = '';

      if (data.entityName == 'Metabolic') {
        this.tabName = "Bloodspot";
      } else {
        this.tabName = data.entityName;
      }
      this.entity = data.entityName;
      this.reportIndexColIsHash = Array.isArray(data.cols) && data.cols[0] === '#';
      this.encColsStr = this.cryptoService.set(data.cols);
      this.reportApiRowData = Array.isArray(data.rowData)
        ? (data.rowData as any[][]).map((row: any[]) => row.slice())
        : [];
      this.applyReportFilterAndSort();

      this.spinnerService.hide();
      this.submitted = false;

      this._ngZone.run(() => {
        this.syncMultiselectEditState();
        this.reportCachedColumnWidths = null;
        setTimeout(() => {
          this.reportViewport?.checkViewportSize();
          this.scheduleReportColumnSync();
        }, 0);
      });




    },
      error => {
        console.log('error in searchQueriesService');
        this.submitted = false;
      });
    // this.submitted = false;
  }







  public componentSelectionEmitter(componentData: object) {
    this._ngZone.run(() => {
      this.componentSelection.emit(componentData);
    });
  }
  public prev() {
    if (this.offset > 0) {
      this.offset = parseInt(this.offset) - parseInt(this.perPage);      
      this.getFilteredData(this.offset);      
    }
  }
  public next() {
    if (this.outputData && this.outputData.rows.length > 0) {
      this.offset = parseInt(this.offset) + parseInt(this.perPage); 
      this.getFilteredData(this.offset);      
    }
  }
  chunk(arr, size) {
    var newArr = [];
    for (var i = 0; i < arr.length; i += size) {
      newArr.push(arr.slice(i, i + size));
    }
    return newArr;
  }

  trackByReportRow = (index: number) => this.getReportRowTrackId(index);

  private getReportRowTrackId(index: number): string | number {
    const row = this.outputData?.rowData?.[index];
    if (!Array.isArray(row)) {
      return index;
    }
    for (const cell of row) {
      if (cell?.colName === 'id' && cell?.value != null && cell?.value !== '') {
        return `id:${cell.value}`;
      }
    }
    for (const cell of row) {
      if (cell?.hasOwnProperty('value') && cell?.value != null && cell?.value !== '' && cell?.dataType !== 'ACTION') {
        return `${cell.colName ?? 'c'}:${cell.value}`;
      }
    }
    return this.encRowStrings[index] ?? index;
  }

  /** Rows loaded from the API for the current page (before toolbar search / column sort). */
  get reportApiRowTotal(): number {
    return this.reportApiRowData?.length ?? 0;
  }

  /** Aligns with DataTables `tr.odd` (first row odd). Needed for sticky cell striping under CDK virtual scroll. */
  isReportRowOdd(rowIndex: number): boolean {
    const o = Number(this.offset) || 0;
    return (o + rowIndex) % 2 === 0;
  }

  /** Columns that are not meaningful to sort (controls / actions). */
  isReportColumnSortable(colIndex: number): boolean {
    const cols = this.outputData?.cols as string[] | undefined;
    const rows = this.outputData?.rowData as any[][] | undefined;
    if (!cols?.length || !rows?.length) {
      return false;
    }
    if (colIndex < 0 || colIndex >= cols.length) {
      return false;
    }
    const label = String(cols[colIndex] ?? '').trim();
    const skipLabels = ['#', 'Select ALL', 'Select ALLs', 'Action(s)', '', 'Favourite'];
    if (skipLabels.includes(label)) {
      return false;
    }
    const meta = rows[0][colIndex];
    if (!meta || typeof meta !== 'object') {
      return false;
    }
    if (meta.colName === 'hidesort') {
      return false;
    }
    if (meta.dataType === 'ACTION') {
      return false;
    }
    return true;
  }

  onReportHeaderSort(colIndex: number, event: MouseEvent): void {
    const t = event?.target as HTMLElement | null;
    if (t?.closest('input')) {
      return;
    }
    if (!this.isReportColumnSortable(colIndex)) {
      return;
    }
    if (this.reportSortColumnIndex === colIndex) {
      this.reportSortAscending = !this.reportSortAscending;
    } else {
      this.reportSortColumnIndex = colIndex;
      this.reportSortAscending = true;
    }
    this.applyReportSort();
  }

  private applyReportSort(): void {
    this.applyReportFilterAndSort({ skipColumnSync: true });
  }

  /**
   * Client-side filter (toolbar "Search for Report") + optional column sort.
   * Works on {@link reportApiRowData} from the last API response for this page.
   */
  private applyReportFilterAndSort(options?: { skipColumnSync?: boolean }): void {
    if (!this.outputData) {
      return;
    }
    const src = this.reportApiRowData;
    if (!src?.length) {
      this.outputData.rowData = [];
      this.reportEncCells = [];
      this.encRowStrings = [];
      this.multiselectSelectedRows = new Set();
      this.checkboxid = [];
      this.syncMultiselectEditState();
      if (!options?.skipColumnSync) {
        this.reportCachedColumnWidths = null;
        this.scheduleReportColumnSync();
      }
      return;
    }

    const q = String(this.searchtext ?? '')
      .trim()
      .toLowerCase();
    let rows = src.map((r) => r.slice());
    if (q) {
      rows = rows.filter((row) => this.reportRowMatchesSearch(row, q));
    }
    if (this.reportSortColumnIndex != null && rows.length > 0) {
      const col = this.reportSortColumnIndex;
      const dir = this.reportSortAscending ? 1 : -1;
      rows.sort((a, b) => this.compareReportRowsAtColumn(a, b, col) * dir);
    }

    this.outputData.rowData = rows;
    this.reportEncCells = rows.map((row: any[]) =>
      row.map((cell: any) => this.cryptoService.set(cell))
    );
    this.encRowStrings = rows.map((row: any[]) => this.cryptoService.set(row));
    this.multiselectSelectedRows = new Set();
    this.checkboxid = [];
    this.syncMultiselectEditState();
    if (options?.skipColumnSync) {
      return;
    }
    this.reportCachedColumnWidths = null;
    this.scheduleReportColumnSync();
  }

  private reportRowMatchesSearch(row: any[], q: string): boolean {
    return this.buildReportRowSearchHaystack(row).includes(q);
  }

  private buildReportRowSearchHaystack(row: any[]): string {
    const parts: string[] = [];
    for (const cell of row) {
      parts.push(this.reportCellSearchFragment(cell));
    }
    return parts.join(' ').toLowerCase();
  }

  private reportCellSearchFragment(cell: any): string {
    if (!cell || typeof cell !== 'object') {
      return '';
    }
    const dt = cell.dataType;
    if (dt === 'ACTION') {
      const a = cell.action;
      if (!a) {
        return '';
      }
      return [a.actionType, a.value, a.pagevalue, a.entityName, a.columnName]
        .filter((x) => x != null && x !== '')
        .map(String)
        .join(' ');
    }
    if (dt === 'Boolean') {
      return cell.value ? 'yes true 1' : 'no false 0';
    }
    if (!cell.hasOwnProperty('value')) {
      return '';
    }
    const v = cell.value;
    if (v === null || v === undefined || v === '') {
      return '';
    }
    if (dt === 'Date') {
      return `${this.sus.getDateByFormat(v, '/', 'mdy')} ${v}`;
    }
    if (dt === 'DateTime') {
      return `${v ? this.sus.convertToEST(v) : ''} ${v}`;
    }
    return String(v);
  }

  private compareReportRowsAtColumn(a: any[], b: any[], colIndex: number): number {
    const ca = a[colIndex];
    const cb = b[colIndex];
    const head = this.outputData?.rowData?.[0]?.[colIndex];
    const dt = (head?.dataType ?? ca?.dataType ?? 'Text') as string;

    const emptyA = this.isReportSortValueEmpty(ca);
    const emptyB = this.isReportSortValueEmpty(cb);
    if (emptyA && emptyB) {
      return 0;
    }
    if (emptyA) {
      return 1;
    }
    if (emptyB) {
      return -1;
    }

    const va = ca.value;
    const vb = cb.value;

    switch (dt) {
      case 'Date':
      case 'DateTime':
        return this.compareReportNumericTimestamps(va, vb);
      case 'Number':
        return this.compareReportNumberValues(va, vb);
      case 'Boolean':
        return va === vb ? 0 : va ? 1 : -1;
      case 'Multiselect':
        return this.compareReportNumberValues(va, vb);
      default:
        return String(va).localeCompare(String(vb), undefined, {
          numeric: true,
          sensitivity: 'base'
        });
    }
  }

  private isReportSortValueEmpty(cell: any): boolean {
    if (cell == null || typeof cell !== 'object') {
      return true;
    }
    if (!cell.hasOwnProperty('value')) {
      return true;
    }
    const v = cell.value;
    return v === null || v === undefined || v === '';
  }

  private compareReportNumericTimestamps(va: any, vb: any): number {
    const ta = this.coerceReportTimeNumber(va);
    const tb = this.coerceReportTimeNumber(vb);
    return ta - tb;
  }

  /** Prefer epoch ms; accept ISO/date strings. */
  private coerceReportTimeNumber(v: any): number {
    const n = Number(v);
    if (Number.isFinite(n) && !Number.isNaN(n)) {
      return n;
    }
    if (typeof v === 'string' && v.trim() !== '') {
      const p = Date.parse(v);
      if (!Number.isNaN(p)) {
        return p;
      }
    }
    return 0;
  }

  /** Numeric when both parse as finite numbers; otherwise natural/alphanumeric. */
  private compareReportNumberValues(va: any, vb: any): number {
    const sa = String(va).trim();
    const sb = String(vb).trim();
    const na = Number(va);
    const nb = Number(vb);
    if (
      sa !== '' &&
      sb !== '' &&
      Number.isFinite(na) &&
      Number.isFinite(nb) &&
      !Number.isNaN(na) &&
      !Number.isNaN(nb)
    ) {
      return na - nb;
    }
    return sa.localeCompare(sb, undefined, { numeric: true, sensitivity: 'base' });
  }

  isMultiselectRowSelected(j: number): boolean {
    return this.multiselectSelectedRows.has(j);
  }

  get multiselectCheckAllChecked(): boolean {
    const n = this.outputData?.rowData?.length ?? 0;
    return n > 0 && this.multiselectSelectedRows.size === n;
  }

  onMultiselectCheckAllChange(ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked;
    const rows = this.outputData?.rowData;
    if (!rows?.length) {
      return;
    }
    if (checked) {
      const next = new Set<number>();
      for (let j = 0; j < rows.length; j++) {
        next.add(j);
      }
      this.multiselectSelectedRows = next;
      // Same as a single-row check: multiEdit() needs entity, columns, and a template row for metadata + form.
      this.editEnityName = this.tabName;
      this.checkAllEditableRows = rows[0];
      try {
        this.checkAllEditableCols = JSON.parse(this.cryptoService.get(this.encColsStr));
      } catch {
        this.checkAllEditableCols = [];
      }
    } else {
      this.multiselectSelectedRows = new Set();
    }
    this.rebuildCheckboxIdsFromMultiselect();
    this.syncMultiselectEditState();
  }

  onMultiselectRowCheckboxChange(rowIndex: number, ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked;
    this.editEnityName = this.tabName;
    if (this.outputData?.rowData?.[rowIndex]) {
      this.checkAllEditableRows = this.outputData.rowData[rowIndex];
      try {
        this.checkAllEditableCols = JSON.parse(this.cryptoService.get(this.encColsStr));
      } catch {
        this.checkAllEditableCols = [];
      }
    }
    const next = new Set(this.multiselectSelectedRows);
    if (checked) {
      next.add(rowIndex);
    } else {
      next.delete(rowIndex);
    }
    this.multiselectSelectedRows = next;
    this.rebuildCheckboxIdsFromMultiselect();
    this.syncMultiselectEditState();
  }

  private rebuildCheckboxIdsFromMultiselect(): void {
    this.checkboxid = [];
    const rows = this.outputData?.rowData ?? [];
    const seen = new Set<any>();
    for (const j of this.multiselectSelectedRows) {
      const row = rows[j];
      if (!row) {
        continue;
      }
      for (const item of row) {
        if (item.dataType === 'ACTION' && item.action?.actionType === 'Edit') {
          const v = item.action.value;
          if (!seen.has(v)) {
            seen.add(v);
            this.checkboxid.push(v);
          }
        }
      }
    }
  }

  private syncMultiselectEditState(): void {
    const dis = this.checkboxid.length > 0;
    const sid = this.componentContext?.id;
    if (sid != null && sid !== '') {
      $(`#data-table${sid} .editReport`).prop('disabled', dis);
    }
  }

  /**
   * CDK virtual scroll applies transform to content — sticky thead inside it breaks.
   * Header is a separate table; we copy column widths from the first body row via colgroup.
   */
  /** Slightly conservative px/char so columns stay tight; refine pass fixes real overflow. */
  private readonly reportColApproxCharPx = 6.65;

  private approxTextWidthPx(text: string, extraPad = 8): number {
    const t = text ?? '';
    return Math.ceil(t.length * this.reportColApproxCharPx) + extraPad;
  }

  /**
   * Minimum col width so thead shows full label + DataTables sort arrows (::before/::after in styles.scss)
   * without touching the next column.
   */
  private reportHeaderLabelMinWidthPx(colIndex: number): number {
    const cols = this.outputData?.cols as string[] | undefined;
    if (!cols?.length || colIndex < 0 || colIndex >= cols.length) {
      return 40;
    }
    const label = String(cols[colIndex] ?? '');
    const sortable = this.isReportColumnSortable(colIndex);
    const pad = sortable ? 52 : 20;
    const labelGap = sortable ? 12 : 0;
    return this.approxTextWidthPx(label, pad) + labelGap;
  }

  /** Wider ceiling for long narrative columns (default 900px clips "Further Details"). */
  private reportColumnGlobalMaxPxForLabel(L: string): number {
    const t = String(L ?? '').trim().toLowerCase();
    if ((t.includes('further') && t.includes('detail')) || t.replace(/\s/g, '') === 'furtherdetails') {
      return 4000;
    }
    return 900;
  }

  /**
   * Narrow control columns only. Do not use broad substrings like "row" (matches Brown, Arrow, …).
   */
  private capWidthByColumnLabel(label: string, widthPx: number): number {
    const L = String(label ?? '').trim().toLowerCase();
    const gMax = this.reportColumnGlobalMaxPxForLabel(L);
    let w = Math.min(widthPx, gMax);
    if (
      (L.includes('date') && (L.includes('created') || L.includes('updated'))) ||
      L.includes('date created') ||
      L.includes('date updated') ||
      L.includes('time created') ||
      L.includes('time updated')
    ) {
      w = Math.min(w, 200);
    }
    if (
      (L.includes('service address') || (L.includes('address') && !L.includes('email'))) &&
      !(L.includes('further') && L.includes('detail'))
    ) {
      w = Math.min(w, 400);
    }
    if (L.includes('service sub type') || (L.includes('sub type') && L.includes('service'))) {
      w = Math.min(w, 280);
    }
    if (
      /\bsub\s*type\b/.test(L) &&
      !L.includes('service type') &&
      !L.includes('case type') &&
      !L.includes('service sub type')
    ) {
      w = Math.min(w, 220);
    }
    if (L === '#' || L === '##') {
      w = Math.min(w, 56);
    }
    if (L.includes('select all') || L === 'select alls') {
      w = Math.min(w, 76);
    }
    if (L.includes('favourite') || L.includes('favorite')) {
      w = Math.min(w, 68);
    }
    if (L.includes('action') && L.includes('(')) {
      w = Math.min(w, 92);
    }
    return Math.max(36, w);
  }

  /** Columns that should not absorb extra width when filling the viewport. */
  private isReportFixedWidthColumn(colIndex: number, label?: string): boolean {
    const cols = this.outputData?.cols as string[] | undefined;
    const L = String(label ?? cols?.[colIndex] ?? '').trim().toLowerCase();
    if (!L) {
      return false;
    }
    if (L === '#' || L === '##' || L.includes('select all') || L.includes('favourite') || L.includes('favorite')) {
      return true;
    }
    if (L.includes('action') && L.includes('(')) {
      return true;
    }
    return false;
  }

  private getReportScrollViewportWidth(root: HTMLElement): number {
    const headX = root.querySelector('.qp-table-head-x') as HTMLElement | null;
    const bodyVp = root.querySelector('.qp-vscroll-viewport') as HTMLElement | null;
    return Math.max(headX?.clientWidth ?? 0, bodyVp?.clientWidth ?? 0, 0);
  }

  /** Spread columns to full grid width so there is no empty band after Action(s). */
  private expandReportColumnWidthsToFillViewport(widths: number[], colLabels: string[]): number[] {
    const sid = this.componentContext?.id;
    const root = sid != null && sid !== '' ? document.getElementById(`data-table${sid}`) : null;
    const viewportWidth = root ? this.getReportScrollViewportWidth(root) : 0;
    if (!viewportWidth) {
      return widths;
    }
    const result = widths.slice();
    const total = result.reduce((sum, w) => sum + w, 0);
    if (total >= viewportWidth) {
      return result;
    }
    const extra = viewportWidth - total;
    const flexible = result
      .map((_, i) => i)
      .filter((i) => !this.isReportFixedWidthColumn(i, colLabels[i] ?? ''));
    if (!flexible.length) {
      return result;
    }
    const flexWeight = flexible.reduce((sum, i) => sum + result[i], 0) || flexible.length;
    let assigned = 0;
    flexible.forEach((colIndex, idx) => {
      const share =
        idx === flexible.length - 1
          ? extra - assigned
          : Math.round(extra * (result[colIndex] / flexWeight));
      result[colIndex] += share;
      assigned += share;
    });
    const remainder = viewportWidth - result.reduce((sum, w) => sum + w, 0);
    if (remainder > 0) {
      result[flexible[flexible.length - 1]] += remainder;
    }
    return result;
  }

  private widthsChangedSignificantly(previous: number[], next: number[]): boolean {
    if (previous.length !== next.length) {
      return true;
    }
    return previous.some((width, index) => Math.abs(width - next[index]) > 1);
  }

  private applyReportColumnWidths(
    widths: number[],
    colLabels: string[],
    headTable: HTMLTableElement,
    bodyTable: HTMLTableElement | null,
    root?: HTMLElement | null
  ): void {
    const finalWidths = this.expandReportColumnWidthsToFillViewport(widths, colLabels);
    const viewportWidth = root ? this.getReportScrollViewportWidth(root) : 0;
    if (
      this.reportCachedColumnWidths &&
      this.reportCachedColumnWidths.length === finalWidths.length &&
      viewportWidth > 0 &&
      this.reportCachedViewportWidth === viewportWidth &&
      !this.widthsChangedSignificantly(this.reportCachedColumnWidths, finalWidths)
    ) {
      return;
    }
    this.applyColGroupCols(headTable, finalWidths);
    if (bodyTable) {
      this.applyColGroupCols(bodyTable, finalWidths);
    }
    this.recomputeStickyOffsetsFromWidths(finalWidths);
    this.reportCachedColumnWidths = finalWidths.slice();
    this.reportCachedViewportWidth = viewportWidth;
  }

  /** Mirrors virtual-row sanitizeOpen for width estimation. */
  private stripForWidthMeasure(v: unknown): string {
    if (v == null) return '';
    return String(v)
      .replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, '')
      .replace(/&nbsp;|[^a-zA-Z0-9 @_.&-]/g, '');
  }

  private formatDefaultCellMeasure(v: unknown): string {
    if (v == null) return '';
    return String(v).replace(/,/g, ', ');
  }

  /**
   * Apply header + colName caps so API field names still clamp when column titles differ
   * (e.g. "Location" vs colName fulladdress).
   */
  private clampReportCellWidthEstimate(cell: any, colIndex: number, px: number): number {
    const cols = this.outputData?.cols as string[] | undefined;
    const header = cols && colIndex >= 0 && colIndex < cols.length ? String(cols[colIndex] ?? '') : '';
    let w = header ? this.capWidthByColumnLabel(header, px) : px;
    const cn = String(cell?.colName ?? '').toLowerCase();
    if (/furtherdetail/i.test(cn) || (header && this.reportColumnGlobalMaxPxForLabel(header) > 900)) {
      return w;
    }
    if (/(address|street|location|servicelocation)/i.test(cn) && !/email/i.test(cn)) {
      w = Math.min(w, 360);
    }
    if ((/created|updated|modified/i.test(cn) && /date|time|dt/i.test(cn)) || /^(created|updated)at$/.test(cn)) {
      w = Math.min(w, 200);
    }
    return w;
  }

  /** Single-cell width estimate (px) from report cell model — aligned with virtual-row display. */
  private approxCellWidthPx(cell: any, colIndex?: number): number {
    const raw = this.approxCellWidthPxRaw(cell);
    if (colIndex == null) {
      return raw;
    }
    return this.clampReportCellWidthEstimate(cell, colIndex, raw);
  }

  private approxCellWidthPxRaw(cell: any): number {
    if (!cell || typeof cell !== 'object') return 44;
    const dt = cell.dataType;
    if (dt === 'Boolean' || dt === 'Favourite') return 44;
    if (dt === 'Multiselect') return 44;
    if (dt === 'ACTION') {
      const t = cell.action?.actionType;
      if (t === 'Edit' || t === 'Open') return 44;
      if (t === 'Link') return 52;
      if (t === 'DCCase') return 160;
      return 48;
    }
    if (dt === 'Date') {
      const s = this.sus.getDateByFormat(cell.value, '/', 'mdy');
      return this.approxTextWidthPx(s);
    }
    if (dt === 'DateTime') {
      const s = cell.value ? this.sus.convertToEST(cell.value) : '';
      return this.approxTextWidthPx(s || ' ');
    }
    if (cell.objectName === 'Person') {
      return this.approxTextWidthPx(String(cell.value ?? ''));
    }
    if (cell.action?.actionType === 'Hide') {
      const basis =
        this.stripForWidthMeasure(cell.value).trim() ||
        this.formatDefaultCellMeasure(cell.value).trim() ||
        ' ';
      return this.approxTextWidthPx(basis, 18);
    }
    if (cell.colName === 'casetype' && !cell.value) {
      return 130;
    }
    if (cell.colName === 'casetype' || cell.colName === 'casesubtype') {
      const s = cell.value ? String(cell.value) : '';
      return this.approxTextWidthPx(s) + 32;
    }
    if (cell.colName === 'incidentstatus') {
      return this.approxTextWidthPx(String(cell.value ?? ''));
    }
    if (!cell.hasOwnProperty('objectName')) {
      const fd = this.formatDefaultCellMeasure(cell.value);
      const vis = this.stripForWidthMeasure(cell.value);
      const basis = vis.trim().length > 0 ? vis : fd;
      return this.approxTextWidthPx(basis.trim() || ' ', 18);
    }
    /** Do not use raw HTML string length (e.g. long hrefs) — same visible text as virtual-row sanitizeOpen. */
    const visible = this.stripForWidthMeasure(cell.value);
    return this.approxTextWidthPx(visible.trim() || ' ', 18);
  }

  private cellHasDisplayContent(cell: any): boolean {
    if (cell == null || typeof cell !== 'object') {
      return false;
    }
    const v = cell.value;
    if (v == null) {
      return false;
    }
    if (typeof v === 'string') {
      return v.trim().length > 0;
    }
    if (typeof v === 'number' || typeof v === 'boolean') {
      return true;
    }
    return String(v).trim().length > 0;
  }

  /** Control columns always “have content” so we don’t shrink them when value is empty. */
  private cellOccupiesColumn(cell: any): boolean {
    if (cell == null || typeof cell !== 'object') {
      return false;
    }
    const dt = cell.dataType;
    if (dt === 'Multiselect' || dt === 'Boolean' || dt === 'Favourite' || dt === 'ACTION') {
      return true;
    }
    return this.cellHasDisplayContent(cell);
  }

  /**
   * Width (px) per column from every loaded row + header labels (no DOM scrollWidth — that inflated gaps).
   */
  private computeReportColumnWidthsFromData(): number[] | null {
    const data = this.outputData;
    if (!data?.rowData?.length || !Array.isArray(data.cols)) {
      return null;
    }
    const cols = data.cols as string[];
    const rows = data.rowData as any[][];
    const n = cols.length;
    const w: number[] = new Array(n).fill(40);
    const hasContent = new Array(n).fill(false);
    if (this.reportIndexColIsHash) {
      hasContent[0] = true;
    }
    for (let i = 0; i < n; i++) {
      w[i] = Math.max(w[i], this.reportHeaderLabelMinWidthPx(i));
    }
    const off = Number(this.offset) || 0;
    for (let r = 0; r < rows.length; r++) {
      const row = rows[r];
      if (!Array.isArray(row) || row.length < n) {
        continue;
      }
      if (this.reportIndexColIsHash) {
        const idx = String(off + r + 1);
        w[0] = Math.max(w[0], this.approxTextWidthPx(idx, 12));
        for (let j = 1; j < n; j++) {
          const cell = row[j];
          if (this.cellOccupiesColumn(cell)) {
            hasContent[j] = true;
          }
          w[j] = Math.max(w[j], this.approxCellWidthPx(cell, j));
        }
      } else {
        for (let j = 0; j < n; j++) {
          const cell = row[j];
          if (this.cellOccupiesColumn(cell)) {
            hasContent[j] = true;
          }
          w[j] = Math.max(w[j], this.approxCellWidthPx(cell, j));
        }
      }
    }
    for (let i = 0; i < n; i++) {
      if (!hasContent[i]) {
        w[i] = this.reportHeaderLabelMinWidthPx(i);
      }
    }
    for (let i = 0; i < n; i++) {
      const lab = String(cols[i] ?? '').trim().toLowerCase();
      const gMax = this.reportColumnGlobalMaxPxForLabel(lab);
      let wi = Math.max(36, Math.min(w[i], gMax));
      if (
        lab.replace(/\s/g, '') === 'sr#' ||
        (lab.includes('sr') && (lab.includes('#') || lab.includes('no') || lab.includes('ref')))
      ) {
        wi = Math.max(wi, 140);
      }
      w[i] = this.capWidthByColumnLabel(String(cols[i] ?? ''), wi);
      w[i] = Math.max(w[i], this.reportHeaderLabelMinWidthPx(i));
    }
    return w;
  }

  private applyColGroupCols(table: HTMLTableElement, widthsPx: number[]): void {
    let cg = table.querySelector('colgroup');
    if (!cg) {
      cg = document.createElement('colgroup');
      table.insertBefore(cg, table.firstChild);
    }
    while (cg.firstChild) {
      cg.removeChild(cg.firstChild);
    }
    let total = 0;
    for (const w of widthsPx) {
      const col = document.createElement('col');
      const px = Math.max(1, Math.round(w));
      col.style.width = `${px}px`;
      cg.appendChild(col);
      total += px;
    }
    table.style.tableLayout = 'fixed';
    table.style.setProperty('width', `${total}px`, 'important');
    table.style.setProperty('min-width', `${total}px`, 'important');
    table.style.setProperty('max-width', `${total}px`, 'important');
  }

  /** True when viewport is wide enough for left/right pinned (sticky) report columns. */
  private isReportStickyColumnsViewport(): boolean {
    if (typeof window === 'undefined') {
      return true;
    }
    return window.innerWidth > this.reportStickyColumnsMaxViewportPx;
  }

  /**
   * Maps API displayfixedpositionstart/end to left/right sticky column counts and cumulative
   * left/right offsets (px) for position:sticky aligned with colgroup widths.
   */
  private recomputeStickyOffsetsFromWidths(widths: number[]): void {
    const n = widths.length;
    if (n === 0) {
      this.reportFixedLeftCols = 0;
      this.reportFixedRightCols = 0;
      this.reportStickyLeftPx = [];
      this.reportStickyRightPx = [];
      return;
    }
    const rawL = this.fixedColStart;
    const rawR = this.fixedColEnd;
    let leftN =
      rawL != null && Number.isFinite(Number(rawL)) && Number(rawL) > 0
        ? Math.floor(Number(rawL))
        : 0;
    let rightN =
      rawR != null && Number.isFinite(Number(rawR)) && Number(rawR) > 0
        ? Math.floor(Number(rawR))
        : 0;
    leftN = Math.min(leftN, n);
    rightN = Math.min(rightN, Math.max(0, n - leftN));
    if (!this.isReportStickyColumnsViewport()) {
      leftN = 0;
      rightN = 0;
    }
    this.reportFixedLeftCols = leftN;
    this.reportFixedRightCols = rightN;

    const rounded: number[] = widths.map((w) => Math.max(1, Math.round(w)));
    const leftOff = new Array(n).fill(0);
    for (let i = 1; i < n; i++) {
      leftOff[i] = leftOff[i - 1] + rounded[i - 1];
    }
    const rightOff = new Array(n).fill(0);
    for (let i = n - 2; i >= 0; i--) {
      rightOff[i] = rightOff[i + 1] + rounded[i + 1];
    }
    this.reportStickyLeftPx = leftOff;
    this.reportStickyRightPx = rightOff;
  }

  /** Sticky styles for thead cells (horizontal scroll in .qp-table-head-x). */
  stickyHeaderStyle(colIdx: number): Record<string, string> | null {
    const n = this.reportStickyLeftPx.length;
    if (n === 0 || colIdx < 0 || colIdx >= n) {
      return null;
    }
    const leftN = this.reportFixedLeftCols;
    const rightN = this.reportFixedRightCols;
    const isLeft = colIdx < leftN;
    const isRight = rightN > 0 && colIdx >= n - rightN;
    if (!isLeft && !isRight) {
      return null;
    }
    const zBase = isLeft ? 5 + colIdx : 5 + (n - 1 - colIdx);
    const styles: Record<string, string> = {
      position: 'sticky',
      zIndex: String(Math.min(60, zBase))
    };
    if (isLeft) {
      styles['left'] = `${Math.round(this.reportStickyLeftPx[colIdx])}px`;
      styles['boxShadow'] = '4px 0 6px -4px rgba(0,0,0,0.12)';
    }
    if (isRight) {
      styles['right'] = `${Math.round(this.reportStickyRightPx[colIdx])}px`;
      styles['boxShadow'] = '-4px 0 6px -4px rgba(0,0,0,0.12)';
    }
    return styles;
  }

  syncReportTableColumnWidths(): void {
    if (this.reportColumnSyncInProgress) {
      return;
    }
    const sid = this.componentContext?.id;
    if (sid == null || sid === '') {
      return;
    }
    const root = document.getElementById(`data-table${sid}`);
    if (!root) {
      return;
    }
    const bodyTable = root.querySelector('.qp-body-table') as HTMLTableElement | null;
    const headTable = root.querySelector('.qp-head-table') as HTMLTableElement | null;
    if (!headTable) {
      return;
    }
    const colLabels = this.outputData?.cols as string[] | undefined;
    const colCount = colLabels?.length ?? 0;
    if (colCount === 0) {
      return;
    }

    const bodyRows = bodyTable?.querySelectorAll('tbody tr') ?? [];
    const headTh = headTable.querySelectorAll('thead th');
    if (headTh.length !== colCount) {
      return;
    }

    const dataWidths = this.computeReportColumnWidthsFromData();
    const widths: number[] =
      dataWidths && dataWidths.length === colCount ? dataWidths.slice() : new Array(colCount).fill(80);
    for (let i = 0; i < colCount; i++) {
      const bump = this.isReportColumnSortable(i) ? 1.022 : 1.006;
      widths[i] = Math.ceil(widths[i] * bump);
      if (colLabels && colLabels[i] != null) {
        widths[i] = this.capWidthByColumnLabel(String(colLabels[i]), widths[i]);
      }
      widths[i] = Math.max(widths[i], this.reportHeaderLabelMinWidthPx(i));
    }

    const pendingWidths = this.expandReportColumnWidthsToFillViewport(widths, colLabels ?? []);
    const viewportWidth = this.getReportScrollViewportWidth(root);
    if (
      this.reportCachedColumnWidths &&
      this.reportCachedColumnWidths.length === pendingWidths.length &&
      viewportWidth > 0 &&
      this.reportCachedViewportWidth === viewportWidth &&
      !this.widthsChangedSignificantly(this.reportCachedColumnWidths, pendingWidths)
    ) {
      return;
    }

    this.reportColumnSyncInProgress = true;
    this.applyReportColumnWidths(widths, colLabels ?? [], headTable, bodyTable, root);
    if (!bodyTable || bodyRows.length === 0) {
      this.reportColumnSyncInProgress = false;
      return;
    }
    const firstRowCells = bodyRows[0].querySelectorAll('td');
    if (firstRowCells.length !== colCount) {
      this.reportColumnSyncInProgress = false;
      return;
    }
    this._ngZone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        this.refineReportColumnWidthsFromOverflow(headTable, bodyTable, colCount, root);
        this.reportColumnSyncInProgress = false;
      });
    });
  }

  /**
   * After colgroup layout, widen only columns where td content still overflows (fixes clipped SR #, dates).
   */
  private refineReportColumnWidthsFromOverflow(
    headTable: HTMLTableElement,
    bodyTable: HTMLTableElement,
    n: number,
    root?: HTMLElement | null
  ): void {
    const rows = bodyTable.querySelectorAll('tbody tr');
    if (rows.length === 0) {
      return;
    }
    const colLabels = this.outputData?.cols as string[] | undefined;
    const maxWForCol = (i: number): number => {
      const lab = colLabels && colLabels[i] != null ? String(colLabels[i]) : '';
      if (!lab) {
        return 900;
      }
      const L = lab.trim().toLowerCase();
      const gMax = this.reportColumnGlobalMaxPxForLabel(L);
      return this.capWidthByColumnLabel(lab, gMax);
    };
    const floorForCol = (i: number): number => this.reportHeaderLabelMinWidthPx(i);
    const firstTds = rows[0].querySelectorAll('td');
    let widths: number[] = this.reportCachedColumnWidths?.slice() ?? [];
    if (widths.length !== n) {
      widths = [];
      for (let i = 0; i < n && i < firstTds.length; i++) {
        widths.push(Math.round((firstTds[i] as HTMLElement).getBoundingClientRect().width));
      }
    }
    if (widths.length !== n) {
      return;
    }
    let changed = false;
    for (let r = 0; r < rows.length; r++) {
      const tds = rows[r].querySelectorAll('td');
      for (let i = 0; i < n && i < tds.length; i++) {
        const td = tds[i] as HTMLElement;
        const cw = td.clientWidth;
        const sw = td.scrollWidth;
        if (sw > cw + 2) {
          const need = Math.ceil(sw + 6);
          const next = Math.max(floorForCol(i), Math.min(need, maxWForCol(i)));
          if (next > widths[i]) {
            widths[i] = next;
            changed = true;
          }
        }
      }
    }
    if (!changed) {
      return;
    }
    for (let i = 0; i < n; i++) {
      if (colLabels && colLabels[i] != null) {
        widths[i] = this.capWidthByColumnLabel(String(colLabels[i]), widths[i]);
      }
      widths[i] = Math.max(widths[i], floorForCol(i));
    }
    this.applyReportColumnWidths(widths, colLabels ?? [], headTable, bodyTable, root);
  }

  scheduleReportColumnSync(): void {
    if (this.reportColumnResizeTimer != null) {
      clearTimeout(this.reportColumnResizeTimer);
    }
    this.reportColumnResizeTimer = setTimeout(() => {
      this.reportColumnResizeTimer = null;
      this.syncReportTableColumnWidths();
    }, 150);
  }

  @HostListener('window:resize')
  onWindowResizeReportGrid(): void {
    this.reportCachedColumnWidths = null;
    this.refreshReportViewportMaxHeight();
    this.scheduleReportColumnSync();
    if (this.showHideFilter) {
      this.sizeFilterPanel();
    }
  }

  /** Fits the open filter panel into the space below the toolbar, so every field and the
   *  Clear / Search buttons stay reachable at any window size or zoom level. */
  sizeFilterPanel(): void {
    setTimeout(() => {
      // Scoped to this tab's own panel: other open SR list tabs have one too
      const host = this.hostRef?.nativeElement;
      const panel = host?.querySelector('.query-filters .popupfilter-srq') as HTMLElement;
      if (!panel) { return; }
      // Measured from the filter button, which is always laid out, rather than from the
      // panel itself, which may not be positioned yet when the dropdown reports it is open
      const anchor = this.toggleButton?.nativeElement?.getBoundingClientRect();
      const panelTop = panel.getBoundingClientRect().top;
      const top = anchor ? anchor.bottom + 10 : panelTop;
      const available = (window.innerHeight || 600) - Math.max(top, panelTop) - 16;
      panel.style.maxHeight = Math.max(160, available) + 'px';
    }, 50);
  }

  /** Caps CDK viewport height; flex layout fills space between toolbar and pagination. */
  private refreshReportViewportMaxHeight(): void {
    try {
      const navbarH = $('.layout-navbar').height() || 56;
      const docH = $(window).height() || 600;
      this.containerHeight = Math.max(200, docH - navbarH - 290) + 'px';
      this.tcontainer = { height: this.containerHeight };
    } catch {
      this.containerHeight = '420px';
      this.tcontainer = { height: this.containerHeight };
    }
    this._ngZone.run(() => {
      setTimeout(() => this.reportViewport?.checkViewportSize(), 0);
    });
  }

  onReportBodyScroll(e: Event): void {
    const el = e.target as HTMLElement;
    const head = this.reportHeadScroll?.nativeElement;
    if (head && head.scrollLeft !== el.scrollLeft) {
      head.scrollLeft = el.scrollLeft;
    }
  }

  onReportHeadScroll(e: Event): void {
    const el = e.target as HTMLElement;
    const vp = this.reportViewport?.elementRef?.nativeElement;
    if (vp && vp.scrollLeft !== el.scrollLeft) {
      vp.scrollLeft = el.scrollLeft;
    }
  }
  edit(data, enityName, id, cols) {

    this._ngZone.run(() => {

      //console.log(cols);
      //console.log(data);
      //console.log(enityName);
      this.rowData = data;
      this.editEnityName = enityName;
      this.editID = id;
      this.metadata.getObjectMetaData(this.editEnityName).subscribe((data: any) => {
        //console.log("Get Object MetaData",data);
        this.objectMetaData = data;
        for (var i = 0; i < this.rowData.length; i++) {
          if (this.rowData[i].editable) {
            if (this.rowData[i].dataType == 'Picklist') {
              //console.log(this.rowData[i].colName);
              let objDetails = this.objectMetaData.columnNames[this.rowData[i].colName];
              let sortable: any = [];
              //console.log(objDetails);
              if (objDetails.hasOwnProperty('pickListValues')) {
                for (var it in objDetails.pickListValues.newIdValues) {
                  if (objDetails.pickListValues.newIdValues[it].active == true) {

                    if (objDetails.ColumnName == "incidentstatus") {
                      if (JSON.parse(this.localStorageService.get('currentUser')).roles[0].id == '11' ||
                          JSON.parse(this.localStorageService.get('currentUser')).roles[0].id == '5') {
                          if (
                              objDetails.pickListValues.newIdValues[it].value == 'Updated' ||
                              objDetails.pickListValues.newIdValues[it].value == "Open"
                          )
                          {
                              continue;
                          }
                      }
                      else {

                          if(
                          objDetails.pickListValues.newIdValues[it].value == 'Updated' ||
                          objDetails.pickListValues.newIdValues[it].value == "Open") {
                              continue;
                          }
                      }
                  }
                    let objSorted: any = {};
                    objSorted.option_label = objDetails.pickListValues.newIdValues[it].value;
                    objSorted.option_value = parseInt(it.replace('key_', ''));
                    if (objSorted.option_label == this.rowData[i].value) {
                      this.rowData[i].dbValue = objSorted.option_value;
                    }
                    sortable.push(objSorted);
                  }
                }
                sortable.sort(this.sus.SortByName);
              }
              this.rowData[i].pickListValues = sortable;
            }
          }
        }
        this.createEditForm(cols);
        // this._appRef.tick();
      })
    });
  }
  createEditForm(cols) {
    this.reportData = [];
    this.headings = cols;
    console.log(this.headings)
    console.log(this.rowData)
    for (var i = 0; i < this.rowData.length; i++) {
      if (this.rowData[i].dataType != 'ACTION') {
        if (this.rowData[i].editable) {
          let tempObj: any = {};
          tempObj.label = this.headings[i];
          if (this.rowData[i].dataType == 'Date' || this.rowData[i].dataType == 'DateTime') {
            tempObj.value = this.sus.getDateByFormat(this.rowData[i].value, '-', 'ymd');
          } else if (this.rowData[i].dataType == 'Picklist') {
            tempObj.pickListValues = this.rowData[i].pickListValues;
            tempObj.value = this.rowData[i].dbValue;
          } else {
            if(this.rowData[i].colName == 'furtherdetails'){
              tempObj.value = "";
            }else{
              tempObj.value = this.rowData[i].value;
            }
          }
          tempObj.formControlName = this.rowData[i].colName;
          tempObj.required = true;
          tempObj.dataType = this.rowData[i].dataType;
          this.reportData.push(tempObj);
        }
      } else {
        if (this.rowData[i].action.actionType == 'Edit') {
          console.log()
          let tempObj: any = {};
          tempObj.formControlName = 'id';
          tempObj.value = this.rowData[i].action.value;
          tempObj.dataType = 'Edit';
          tempObj.label = '';
          this.reportData.push(tempObj);
        }
      }
    }
    //console.log(this.reportData);
    //Creating fields and validation------//////////////////////
    for (var i = 0; i < this.reportData.length; i++) {
      let formControlData: any = [];
      if (this.reportData[i].required) {
        formControlData.push(this.reportData[i].value);
        //formControlData.push(Validators.required);
      } else {
        formControlData.push(this.reportData[i].value);
      }
      this.fbGpObject[this.reportData[i].formControlName] = formControlData;

    }
    console.log(this.reportData)

    //console.log(this.fbGpObject);
    //this.reportData = this.chunk(this.reportData,0);

    //Creating dynamic report form group//////////////////////////////////
    this.editReportForm = this.formBuilder.group(this.fbGpObject);
    this.modalService.open(this.reportPopupForm, { backdrop: 'static', keyboard: false, windowClass: ' animate reportForm', size: 'xs' })
    // this._detectChanges.detectChanges();
    // this._appRef.tick();

  }
  get editReportFormData() { return this.editReportForm.controls; }
  onSubmitEditReport(c) {
    console.log(this.reportData);
    this.submitted = true;
    //console.log(this.editReportForm.invalid);
    if (this.editReportForm.invalid) {
      return;
    }
    console.log(this.editReportForm.value);
    // return false;
    for (let i in this.editReportForm.value) {
      if (this.objectMetaData.columnNames[i].Datatype == 'Date') {
        this.editReportForm.value[i] = this.sus.getTimeStampDate(this.editReportForm.value[i]);
      } else if (this.objectMetaData.columnNames[i].Datatype == 'DateTime') {
        this.editReportForm.value[i] = this.sus.getTimeStampDate(this.editReportForm.value[i]);
      } else if (this.objectMetaData.columnNames[i].Datatype.toLowerCase() == 'picklist') {
        this.editReportForm.value[i] = parseInt(this.editReportForm.value[i]);
      }
    }
    //this.editReportForm.value

    let payload: any = {
      "entityName": this.editEnityName,
      "payLoad": this.editReportForm.value
    }
    //console.log(this.checkboxid);
    //console.log(payload);
    if (this.checkboxid.length > 0) {
      let multiEditPayload: any = [];
      for (let i = 0; i < this.checkboxid.length; i++) {
        let tempObj = {
          "id": this.checkboxid[i],
          "incidentstatus": this.editReportForm.value.incidentstatus,
          'furtherdetails' : this.editReportForm.value.furtherdetails,
        }
        multiEditPayload.push(tempObj);
      }
      payload.payLoad = multiEditPayload;
      console.log(payload);
      //return false;
      this.objc.queryReportMultiUpdate(payload).subscribe((success) => {
        //console.log(success);
        c('Close');
        if (success) {
          this.checkboxid = [];
          Swal.fire({
            title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >Saved successfully!</div></div>',
            icon: 'success',
            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
imageHeight: 45,
showCloseButton: true,
           
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: `Ok`,
          })
          //$('.pane:visible .search').trigger('click');
          this.getFilteredData(this.offset);
        } else {
          Swal.fire('Oops...!', 'Something went wrong, Please try again.', 'error');
        }
      })
    } else {
      // alert()
      //this.objc.queryReportCreate(payload).subscribe((success) => {
      let newPayload = [];
      newPayload.push(payload.payLoad);
      payload.payLoad = newPayload;
      //console.log(payload); return false;
      this.objc.queryReportMultiUpdate(payload).subscribe((success) => {
        //console.log(success);
        c('Close');
        if (success) {
          Swal.fire({
            title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >Saved successfully!</div></div>',
            icon: 'success',
            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
imageHeight: 45,
showCloseButton: true,
         
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonText: `Ok`,
          })
          //$('.pane:visible .search').trigger('click');
          this.getFilteredData(this.offset);
        } else {
          Swal.fire('Oops...!', 'Something went wrong, Please try again.', 'error');
        }
      })
    }
    //console.log("Get Object MetaData",this.objectMetaData);
  }

  convertDate(data) {
    return this.sus.getDate(data);
  }
  downLoadExcel() {
    if (this.outputData?.rowData?.length) {
      this.exportReportToCsv();
    }
  }

  /**
   * Query row cells may carry Unix seconds or ms; CSV should not emit raw numbers (Excel shows scientific notation).
   */
  private parseReportCellTimestamp(raw: any): Date | null {
    if (raw == null || raw === '') {
      return null;
    }
    if (typeof raw === 'number' && Number.isFinite(raw)) {
      const n = raw;
      if (Math.abs(n) < 1e11) {
        return new Date(n * 1000);
      }
      return new Date(n);
    }
    if (typeof raw === 'string') {
      const t = raw.trim();
      if (/^[-+]?(?:\d+\.?\d*|\d*\.?\d+)(?:[eE][-+]?\d+)?$/.test(t)) {
        return this.parseReportCellTimestamp(Number(t));
      }
    }
    const d = new Date(raw);
    return isNaN(d.getTime()) ? null : d;
  }

  /** CSV / Excel-friendly display for Date and DateTime grid cells. */
  private formatReportCellForCsv(cell: any, raw: any): string {
    if (raw == null || raw === '') {
      return '';
    }
    if (!cell || typeof cell !== 'object') {
      return String(raw);
    }
    const dt = cell.dataType;
    if (dt !== 'Date' && dt !== 'DateTime') {
      return 'value' in cell ? String((cell as any).value ?? '') : String(raw);
    }
    const d = this.parseReportCellTimestamp(raw);
    if (!d) {
      return String(raw);
    }
    if (dt === 'Date') {
      return this.sus.getDate(d.getTime());
    }
    return d.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  }

  private exportReportToCsv(): void {
    const cols = this.outputData.cols || [];
    const rows = this.outputData.rowData || [];
    const esc = (s: string) => '"' + String(s ?? '').replace(/"/g, '""') + '"';
    // UI-only columns (checkbox, favourite star, row actions) are not exported.
    const excludedCols = ['select all', 'select alls', 'favourite', 'action(s)'];
    const exportIdx: number[] = [];
    cols.forEach((c, i) => {
      if (!excludedCols.includes(String(c ?? '').trim().toLowerCase())) {
        exportIdx.push(i);
      }
    });
    const lines: string[] = [exportIdx.map((i) => esc(String(cols[i] ?? ''))).join(',')];
    for (let j = 0; j < rows.length; j++) {
      const r = rows[j];
      const cells: string[] = [];
      for (const k of exportIdx) {
        const cell = r[k];
        let v: any = '';
        if (cell && typeof cell === 'object' && 'value' in cell) {
          v = (cell as any).value;
        } else if (cell != null) {
          v = cell;
        }
        const out =
          cell && typeof cell === 'object' && ('dataType' in cell || 'value' in cell)
            ? this.formatReportCellForCsv(cell, v)
            : v == null
              ? ''
              : String(v);
        cells.push(esc(out));
      }
      lines.push(cells.join(','));
    }
    const blob = new Blob([lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = (this.componentContext?.name || 'report') + '.csv';
    a.click();
    URL.revokeObjectURL(url);
  }
  showfilters() {
    this.showHideFilter = !this.showHideFilter;
    $('.overlay').toggleClass('active');
  }
  closeFilter() {
    this.showHideFilter = false;
    //$('.overlay.active').removeClass('active');
  }
  clear() {
    this.queryProcessorFormGroup.reset();
  }
  getArray(data) {
    //console.log(data)
    var finalArray = data.map(function (obj) {
      return obj.key;
    });
    return finalArray;
  }
  /** Toolbar "Search for Report" — filters current page rows (client-side). */
  onReportToolbarSearch(): void {
    this.applyReportFilterAndSort();
  }
  multiEdit() {
    console.log(this.checkAllEditableCols);
    console.log(this.checkAllEditableRows);
    console.log(this.checkboxid);
    console.log(this.editEnityName);
    this.edit(this.checkAllEditableRows, this.editEnityName, this.checkboxid, this.checkAllEditableCols);
  }
  perPagechange() {
    this.pageNo = 1;
    this.searchtext = '';
    this.getFilteredData(0);
  }
  refresh(){
    this.perPagechange();
  }
  refreshPagination(){       
    this.currentPage = parseInt(this.offset) + 1; 
    if(this.offset == 0) {
      this.pageNo = 1;
    }else{
      this.pageNo = (parseInt(this.offset) / parseInt(this.perPage)) + 1;
    }    
  }
  addToFav(payload){    
    setTimeout(() => {
      this._ngZone.run(() => {              
        //return false;
        this.sus.saveFavorite(payload).subscribe((data:any)=>{
          console.log(payload);
          //this.refresh();
        });
      })
    })
  }
  activeFav = false;
  getMyFavs(){ 
    //console.log(this.sus.getDefaultFilterData());
    this.activeFav = true;
    this.clear();
    this.queryProcessorFormGroup.patchValue({"fav":"true"});
    this.menu.onSubmit(undefined);    
    //console.log(this.queryProcessorFormGroup.value);
  }
  clearFav(event:Event){
    console.log(this.sus.getReadOnlyInput());
    this.activeFav = false;
    event.stopPropagation();
    this.clear();   
    if(this.sus.getReadOnlyInput() && this.sus.getReadOnlyInput().hasOwnProperty('formcontrolname')){
      let readonlydata = {};
      readonlydata[this.sus.getReadOnlyInput().formcontrolname] = this.sus.getReadOnlyInput().value;
      this.queryProcessorFormGroup.patchValue(readonlydata);
    }
    this.queryProcessorFormGroup.patchValue({"incidentstatus":this.sus.getDefaultFilterData()});   
    this.menu.onSubmit(undefined);   
  }
}

